import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import WorkstationStatusContent from '../../Dashboard/Boards/WorkstationStatusContent';
import OEEContent from '../../Dashboard/Boards/OEEContent';
import BackForwardButton from '../../Shared/BackForwardButton'
import { NavLink } from "react-router-dom";
import ShiftPerformanceContent from '../../Dashboard/Boards/ShiftPerformanceContent';
import WorkstationMessagesContent from '../../Dashboard/Boards/WorkstationMessagesContent';
import ProgressionChart from '../../Dashboard/Charts/ProgressionChart';
import SettingsIcon from '@material-ui/icons/Settings';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import DashboardConfigurationDrawer from '../../Dashboard/DashboardConfigurationDrawer';
import { connect } from 'react-redux';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import ProductionOrderOrderContent from '../../Dashboard/Boards/ProductionOrderContent';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import SpeedChart from '../../Dashboard/Charts/SpeedChart';

export const DashboardPage = (props) => {
    const classes = useStyles();
    const [workstation, setWorkstation] = useState([]);
    const [previousWorkstationId, setPreviousWorkstationId] = useState(0);
    const [nextWorkstationId, setNextWorkstationId] = useState(0);
    const [workstations, setWorkstations] = useState([])
    const [progressions, setProgressions] = useState([])
    const [statusses, setStatusses] = useState([])
    const [currentOrder, setCurrentOrder] = useState(null)
    const [nextOrder, setNextOrder] = useState(null)

    useEffect(() => {

        let currentWorkstation = props.workstationState.workstationsWithScissorStatusInfo.find(x => String(x.id) === props.match.params.id)
        if (JSON.stringify(workstation) !== JSON.stringify(currentWorkstation)) {
            setWorkstation(currentWorkstation)
        }

        let indexCurrentWorkstation = props.workstationState.workstationsWithScissorStatusInfo.indexOf(currentWorkstation)
        if (indexCurrentWorkstation > 0) {
            if (previousWorkstationId !== props.workstationState.workstationsWithScissorStatusInfo[indexCurrentWorkstation - 1].id) {
                setPreviousWorkstationId(props.workstationState.workstationsWithScissorStatusInfo[indexCurrentWorkstation - 1].id)
            }
        }
        if (indexCurrentWorkstation < props.workstationState.workstationsWithScissorStatusInfo.length - 1) {
            if (nextWorkstationId !== props.workstationState.workstationsWithScissorStatusInfo[indexCurrentWorkstation + 1].id) {
                setNextWorkstationId(props.workstationState.workstationsWithScissorStatusInfo[indexCurrentWorkstation + 1].id)
            }
        }
        dataService.getWorkstationStatusses().then((statuses) => {
            if (JSON.stringify(statuses.body) !== JSON.stringify(statusses)) {
                setStatusses(statuses.body)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        dataService.getProgressions().then((list) => {
            if (JSON.stringify(list.body) !== JSON.stringify(progressions)) {
                setProgressions(list.body)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        dataService.getWorkstations().then((stations) => {
            if (JSON.stringify(stations.body) !== JSON.stringify(workstations)) {
                setWorkstations(stations.body)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getProductionOrdersByMachine(parseInt(props.match.params.id)).then(orders => {

            let activeOrders = orders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED && x.productionOrderStatus !== state.PLANNED).sort((a, b) => new Date(a.startedOn) - new Date(b.startedOn))
            let plannedOrders = orders.filter(x => x.productionOrderStatus === state.PLANNED).sort((a, b) => new Date(a.startedOnPlanned) - new Date(b.startedOnPlanned))
           
            if(activeOrders.length > 0){
                setCurrentOrder(activeOrders[0])
            }
            else{
                setCurrentOrder(null)
            }

            if(plannedOrders.length > 0){
                setNextOrder(plannedOrders[0])
            }
            else{
                setNextOrder(null)
            }  

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [])

    const openDashboardConfigurationDrawer = (open) => {
        props.actions.setDashboardConfigurationDrawerOpen(open);
    }

    return <div className={classes.background}>{nextOrder ? <React.Fragment>
        <div className={classes.header}><React.Fragment><div><button className={classes.title}>Line {workstation.id} dashboard</button></div>
            <button className={classes.settingsButton} onClick={() => openDashboardConfigurationDrawer(true)}><SettingsIcon className={classes.settingsIcon}></SettingsIcon></button>
            {workstation.id === props.workstationState.workstationsWithScissorStatusInfo.length ? <React.Fragment></React.Fragment>
                :
                <div className={classes.next}>
                    <NavLink className={classes.navButton} to={`/dashboard/${(String(nextWorkstationId))}`}>
                        <BackForwardButton direction={'forward'}></BackForwardButton>
                    </NavLink>
                </div>}

            {workstation.id !== 1 ? <div className={classes.previous}>
                <NavLink className={classes.navButton} to={`/dashboard/${(String(previousWorkstationId))}`}>
                    <BackForwardButton textOverride={"previous"} direction={'Back'}></BackForwardButton>
                </NavLink>
            </div> : <React.Fragment></React.Fragment>}
        </React.Fragment>
        </div>
        <div className={classes.main}>
            <div className={classes.leftDashboard}>
                {props.dashboard.currentOrderBoard && <div className={classes.currentOrderContainer}>
                    <ProductionOrderOrderContent order={currentOrder} current={true}></ProductionOrderOrderContent>
                </div>}
                {props.dashboard.nextOrderBoard && <div className={classes.nextOrderContainer}>
                    <ProductionOrderOrderContent order={nextOrder} current={false}></ProductionOrderOrderContent>
                </div>}
                <div className={classes.statusContainer}>
                    <WorkstationStatusContent statusses={statusses} line={workstation} {...props} actions={props.actions}></WorkstationStatusContent>
                </div>
                {props.dashboard.shiftPerformanceBoard ? <div className={classes.shiftPerformanceContainer}>
                    <ShiftPerformanceContent fakeDataWorkstation={workstations.find(x => x.id === workstation.id)} workstation={workstation}></ShiftPerformanceContent>
                </div> : <React.Fragment></React.Fragment>}
            </div>
            {props.dashboard.OEEBoard ? <div className={classes.middleDashboard}>
                <OEEContent fakeDataWorkstation={workstations.find(x => x.id === workstation.id)} ></OEEContent>
            </div> : <React.Fragment></React.Fragment>}
            <div className={classes.rightDashboard}>

                {props.dashboard.progressionBoard ? <ProgressionChart order={currentOrder} progressions={progressions} fakeDataWorkstation={workstations.find(x => x.id === workstation.id)} ></ProgressionChart> : <React.Fragment></React.Fragment>}
                {props.dashboard.speedBoard && <SpeedChart></SpeedChart>}
                {props.dashboard.messagesBoard ? <WorkstationMessagesContent fakeDataWorkstation={workstations.find(x => x.id === workstation.id)}  ></WorkstationMessagesContent> : <React.Fragment></React.Fragment>}
            </div>
        </div>
        <DashboardConfigurationDrawer openDrawer={openDashboardConfigurationDrawer} drawerOpen={props.dashboard.dashboardConfigurationDrawerOpen} {...props} actions={props.actions}></DashboardConfigurationDrawer>

    </React.Fragment> :
        <React.Fragment></React.Fragment>}
    </div>
}

const useStyles = makeStyles({
    main: {
        width: "100%",
        height: "calc(100% - 55px)"
    },
    leftDashboard: {
        width: "38%",
        float: "left"
    },
    rightDashboard: {
        height: "fit-content",
        borderRadius: "6px",
        marginLeft: "10px",
        width: "calc(60% - 200px)",
        float: "left"
    },
    middleDashboard: {
        width: "200px",
        height: "fit-content",
        backgroundColor: "white",
        marginLeft: "10px",
        borderRadius: "6px",
        float: "left"
    },
    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        float: "left",
        border: "none",
        outline: "none"
    },
    statusContainer: {
        height: "auto",
        backgroundColor: "white",
        marginBottom: "10px",
        padding: "20px",
        borderRadius: "6px"
    },
    currentOrderContainer: {
        height: "auto",
        backgroundColor: "white",
        marginBottom: "10px",
        padding: "20px",
        borderRadius: "6px"
    },
    nextOrderContainer: {
        height: "auto",
        backgroundColor: "white",
        marginBottom: "10px",
        padding: "20px",
        borderRadius: "6px"
    },
    shiftPerformanceContainer: {
        height: "fit-content",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",
        paddingBottom: "57px"
    },
    background: {
        padding: "20px",
        marginTop: "40px"
    },
    header: {
        height: "55px"
    },
    previous: {
        float: "right",
    },
    nextButton: {
        float: "right"
    },
    navButton: {
        textDecoration: "none"
    },
    next: {
        float: "right"
    },

    messages: {
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px"
    },
    settingsIcon: {
        color: FlagstoneTheme.palette.primary.main,
    },
    settingsButton: {
        border: "none",
        outline: "none",
        cursor: "pointer"
    }

});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
        dashboard: state.dashboard
    }
}

export default connect(mapStateToProps)(DashboardPage)